"use client";
import React from 'react';
import { FAQIcon } from './FAQIcon';

export const FAQItem = ({ question, answer, isExpanded, onToggle }) => {
  if (isExpanded && answer) {
    return (
      <article className="d-flex flex-column p-4 rounded" style={{ backgroundColor: '#16a34a', gap: '14px' }}>
        <button
          className="btn d-flex justify-content-between align-items-center w-100 text-start p-0 border-0"
          style={{ backgroundColor: 'transparent' }}
          onClick={onToggle}
          aria-expanded={isExpanded}
        >
          <h3 className="fw-bold text-white mb-0 flex-grow-1" style={{ fontSize: '1rem' }}>
            {question}
          </h3>
          <FAQIcon isExpanded={isExpanded} />
        </button>
        <p className="fw-medium mb-0" style={{ color: '#bbf7d0', fontSize: '1rem' }}>
          {answer}
        </p>
      </article>
    );
  }

  return (
    <article className="d-flex flex-column py-4 px-4 border-bottom" style={{ gap: '14px', borderColor: '#d4d4d8 !important' }}>
      <button
        className="btn d-flex justify-content-between align-items-center w-100 text-start p-0 border-0"
        style={{ backgroundColor: 'transparent' }}
        onClick={onToggle}
        aria-expanded={isExpanded}
      >
        <h3 className="fw-bold mb-0 flex-grow-1" style={{ color: '#404040', fontSize: '1rem' }}>
          {question}
        </h3>
        <FAQIcon isExpanded={isExpanded} />
      </button>
    </article>
  );
};
